import { catalogQueryKeys } from './catalog'
import { favoriteQueryKeys } from './favorites'
import { productQueryKeys } from './products'
import { searchQueryKeys } from './search'
import { sharedQueryKeys } from './shared'

export const queryKeys = {
  ...catalogQueryKeys,
  ...favoriteQueryKeys,
  ...productQueryKeys,
  ...searchQueryKeys,
  ...sharedQueryKeys,
}
